import { Route, Switch } from 'react-router-dom';
import Forms from '../containers/Forms';
import LiveChat from '../containers/LiveChat';
import LiveChatIntermediate from '../containers/LiveChatIntermediate';
import Meetings from '../containers/Meetings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Paths = {
  FORMS: '/forms',
  LIVE_CHAT: '/live-chat',
  LIVE_CHAT_INTERMEDIATE: '/live-chat-intermediate',
  MEETINGS: '/meetings',
  MEETINGS_EMBEDDED: '/meetings-embedded'
};
export const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    path: Paths.FORMS,
    exact: true,
    component: Forms
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.MEETINGS,
    exact: true,
    component: Meetings
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.MEETINGS_EMBEDDED,
    exact: true,
    component: Meetings
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.LIVE_CHAT,
    exact: true,
    component: LiveChat
  }), /*#__PURE__*/_jsx(Route, {
    path: Paths.LIVE_CHAT_INTERMEDIATE,
    exact: true,
    component: LiveChatIntermediate
  })]
});